var _style, _rect, _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1417.3 1417.3",
    style: {
      enableBackground: "new 0 0 1417.3 1417.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#74A3AF;}\n\t.st1{clip-path:url(#SVGID_00000159455255125478744180000012016585927145306804_);}\n\t.st2{fill:#89BAC8;}\n\t.st3{fill:#ED6F72;}\n\t.st4{fill:#4E4D4D;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    x: 670.9,
    y: 338.2,
    className: "st0",
    width: 77.8,
    height: 77.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2869"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 341.7,
    y: 282,
    width: 736.2,
    height: 844
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140006029351712625780000005782343650598874295_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2868",
    style: {
      clipPath: "url(#SVGID_00000140006029351712625780000005782343650598874295_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19299",
    className: "st2",
    d: "M958.5,486.7l21.9-28.5c5.6-7.3,4.3-17.8-3-23.4c0,0,0,0,0,0l-35.2-27 c-7.3-5.6-17.8-4.3-23.4,3c0,0,0,0,0,0L896,440.4C720.3,337,494.1,395.6,390.7,571.2s-44.8,401.9,130.8,505.4 s401.9,44.8,505.4-130.8C1115.2,795.8,1086.7,604.5,958.5,486.7 M864.7,1008.9l-21.2-36.7l-14.9,8.6l21.3,36.8 c-40.4,21.9-85.4,33.9-131.4,35.2v-42.5h-17.3v42.5c-45.9-1.3-90.9-13.3-131.4-35.2l21.3-36.8l-15-8.6l-21.2,36.7 c-39-24.2-72-57.1-96.1-96.1l36.7-21.2l-8.6-15L450,897.8c-21.9-40.4-33.9-85.4-35.2-131.4h42.5v-17.3h-42.5 c1.3-45.9,13.3-90.9,35.2-131.4l36.8,21.3l8.6-14.9L458.7,603c24.2-39.1,57.1-72,96.2-96.2l21.2,36.7l14.9-8.6l-21.3-36.8 c40.4-21.9,85.4-33.9,131.4-35.2v42.5h17.3v-42.5c45.9,1.3,90.9,13.3,131.4,35.2l-21.3,36.8l14.9,8.6l21.2-36.7 c39.1,24.2,72,57.1,96.2,96.1l-36.7,21.2l8.6,14.9l36.8-21.3c21.9,40.4,33.9,85.4,35.2,131.4h-42.5v17.3h42.5 c-1.3,45.9-13.3,90.9-35.2,131.4l-36.8-21.3l-8.6,14.9l36.7,21.2C936.6,951.7,903.7,984.6,864.7,1008.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19300",
    className: "st2",
    d: "M764.6,352.9H655c-9.2,0-16.7-7.5-16.7-16.7v0v-37.6c0-9.2,7.5-16.7,16.7-16.7 c0,0,0,0,0,0h109.6c9.2,0,16.7,7.5,16.7,16.7c0,0,0,0,0,0v37.5C781.3,345.4,773.8,352.9,764.6,352.9L764.6,352.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19301",
    className: "st3",
    d: "M813.2,579.2c-31.3-18.1-66.9-27.7-103.1-27.8l-0.3,206.4l178.9-103.1 C870.6,623.4,844.5,597.3,813.2,579.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19302",
    className: "st4",
    d: "M899,643l-165.2,81.9c-18.2-13.3-43.7-9.2-56.9,8.9c-13.3,18.2-9.2,43.7,8.9,56.9 c18.2,13.3,43.7,9.2,56.9-8.9c5.1-7,7.8-15.4,7.8-24c0-1.7-0.1-3.4-0.3-5.1l152.9-102.5c1.9-1.3,2.4-3.9,1.1-5.8 C903.1,642.7,900.9,642.1,899,643"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.1311d850e831e2c28f2d652707f44057.svg";
export { ForwardRef as ReactComponent };